// frontend/src/utils/documentPayloadBuilder.js

export const buildPlanAnualLightPayload = (contextState, formData) => {
  // 1. Extraemos todo el contexto necesario, INCLUYENDO LAS SESIONES 🌟
  const { 
    area, 
    grado, 
    periodos, 
    unidades, 
    asignaciones, 
    calendario,
    semanasVacaciones,
    semanasGestion,
    enfoquesUnidades,
    sesiones // <-- 🌟 AQUÍ EXTRAEMOS LAS SESIONES
  } = contextState; 

  // Limpieza del color hexadecimal
  const colorHexLimpio = formData.colorCeldas 
    ? formData.colorCeldas.replace('#', '').toUpperCase() 
    : "331144";

  // 2. Formateamos las unidades para inyectarles sus enfoques directamente
  const unidadesFormateadas = unidades.map(unidad => ({
    ...unidad,
    enfoques_asignados: enfoquesUnidades[unidad.id] || []
  }));

  // 3. Armamos el payload estructurado
  return {
    metadatos: {
      institucion_educativa: formData.institucion || "",
      docente: formData.docente || "",
      color_primario: colorHexLimpio
    },
    parametros_db: {
      area_id: area?.id || null,
      grado_id: grado?.id || null,
      nivel_id: grado?.nivel_id || null 
    },
    planificacion_dinamica: {
      calendario: {
        total_semanas: calendario.length,
        detalle_semanas: calendario,
        semanas_vacaciones: semanasVacaciones,
        semanas_gestion: semanasGestion
      },
      periodos: periodos,
      unidades: unidadesFormateadas,
      asignaciones: asignaciones,
      sesiones: sesiones // <-- 🌟 AQUÍ LAS ENVIAMOS EN EL PAYLOAD
    }
  };
};
